/**
 * TTL-based cache for holdings (liquidity pools + portfolio) to avoid repeated API calls.
 */

import type { LiquidityPool } from "features/wallet";
import type { DerivedPosition } from "types/Portfolio";

const TTL_MS = 5 * 60 * 1000; // 5 minutes

interface CachedHoldings {
    pools: LiquidityPool[];
    positions: DerivedPosition[];
    timestamp: number;
}

const cache = new Map<string, CachedHoldings>();

export function getCachedHoldings(username: string): { pools: LiquidityPool[]; positions: DerivedPosition[] } | null {
    const entry = cache.get(username);
    if (!entry) return null;
    if (Date.now() - entry.timestamp > TTL_MS) {
        cache.delete(username);
        return null;
    }
    return { pools: entry.pools, positions: entry.positions };
}

export function setCachedHoldings(
    username: string,
    pools: LiquidityPool[],
    positions: DerivedPosition[]
): void {
    cache.set(username, { pools, positions, timestamp: Date.now() });
}

export function invalidateHoldingsCache(username?: string): void {
    if (username) {
        cache.delete(username);
    } else {
        cache.clear();
    }
}
